import { onDomReady } from 'utils/onDomReady'
import { on } from 'delegated-events'

onDomReady(() => {
  const body = document.querySelector('body')
  const hamburger = document.querySelector('.hamburger')
  const navigation = document.querySelector('.navigation')
  const navigationList = document.querySelector('.navigation-list')
  const mobileOverlay = document.querySelector('.navigation-mobile-overlay')

  const resetMobileSubmenus = () => {
    document.querySelectorAll('.navigation-submenu').forEach(el => {
      el.classList.remove('open')
    })

    if (navigationList) {
      navigationList.classList.remove('submenu-visible')
    }
  }

  function handleFadeOutTransitionEnd() {
    navigation.classList.remove('visible')
    navigationList.removeEventListener(
      'transitionend',
      handleFadeOutTransitionEnd
    )
  }

  const toggleDrawer = () => {
    body.classList.toggle('scroll-disabled')
    hamburger.classList.toggle('open')
    if (mobileOverlay) mobileOverlay.classList.toggle('active')

    const isVisible = navigation.classList.contains('visible')

    if (isVisible) {
      navigationList.addEventListener(
        'transitionend',
        handleFadeOutTransitionEnd
      )
      navigationList.classList.remove('fade-in')

      resetMobileSubmenus()
    } else {
      navigation.classList.add('visible')

      setTimeout(() => {
        navigationList.classList.add('fade-in')
      }, 100)
    }
  }

  if (hamburger) {
    hamburger.addEventListener('click', toggleDrawer)
  }

  function closeNavigationMenu() {
    body.classList.remove('scroll-disabled')
    hamburger.classList.remove('open')
    if (mobileOverlay) mobileOverlay.classList.remove('active')

    if (navigationList) {
      navigationList.addEventListener(
        'transitionend',
        handleFadeOutTransitionEnd
      )
      navigationList.classList.remove('fade-in')
    }

    resetMobileSubmenus()
  }

  on(
    'click',
    `.navigation-submenu__link, .navigation-item-button--single, .navigation-sign-up, .navigation-action, .support-beacon, .navigation-submenu-links__item--anchor`,
    closeNavigationMenu
  )
})
